import {BaseService} from "@/services/BaseService";
import {IContract} from "@/shared/domain/contract.model";
import http from "@/http-common";
import { ContractInfoCheckReturn } from "@/shared/domain/custom/contract-info-check-return";
import {MagContract} from "@/shared/domain/mag-contract.model";

class ContractService extends BaseService<IContract>{
  public entityUrl = "contracts";

  public validateContractEmail(cpfCnpj: string, emailToValidate: string) {
    return http.get<ContractInfoCheckReturn>(`${this.entityUrl}/validateContractEmail/${cpfCnpj}/${emailToValidate}`);
  }

  public validateContractCpfCnpj(email: string, cpfCnpjToValidate: string) {
    return http.get<ContractInfoCheckReturn>(`${this.entityUrl}/validateContractCpfCnpj/${email}/${cpfCnpjToValidate}`);
  }

  public createAndProcessPayment(contract: any) {
    return http.post<any>(`${this.entityUrl}/createAndProcessPayment`, contract);
  }

  public processPayment(contract: any) {
    return http.put<any>(`${this.entityUrl}/credit/process`, contract);
  }

  public getContractStatus(id: number) {
    return http.get<any>(`${this.entityUrl}/status/${id}/verify`);
  }


  public generateNewContract(isPrevent: boolean, contract: any) {
    if (isPrevent) {
      return this.createPreventContract(contract);
    }
    return this.createLostSomeoneContract(contract);
  }

  public createMagContract(contract: MagContract) {
    return http.post<any>(`${this.entityUrl}/mag`, contract);
  }

  public createLostSomeoneContract(contract: any) {
    return http.post<any>(`${this.entityUrl}/createLostSomeoneContract`, contract);
  }

  public createPreventContract(contract: any) {
    return http.post<any>(`${this.entityUrl}/createPreventContract`, contract);
  }

  public getPixCode(contractPix: any) {
    return http.put<any>(`${this.entityUrl}/pix/generate`, contractPix);
  }

  public updateAndProcessPayment(contract: any) {
    return http.post<any>(`${this.entityUrl}/updateAndProcessPayment`, contract);
  }

  public repaySubscription(repayData: any, token: string) {
    return http.post<any>(`${this.entityUrl}/repaySubscription/${token}`, repayData);
  }

  public checkPayment(contractId: number) {
    return http.get<any>(`${this.entityUrl}/checkPayment/${contractId}`);
  }

  public payPendingContractPayment(contractId: number, contractPaymentToFix: any) {
    return http.post<any>(`${this.entityUrl}/payPendingContractPayment/${contractId}`, contractPaymentToFix);
  }
  public getAllLoggedUserContracts() {
    return http.get<IContract[]>(`${this.entityUrl}/user`);
  }

  findByRepayToken(repayToken: string) {
    return http.get<IContract>(`${this.entityUrl}/repaySubscription/${repayToken}/`);
  }

  updateContract(id: any) {
    return http.get<any>(`${this.entityUrl}/verify/${id}`);
  }

  verifyPixTransactions(txId: any) {
    return http.get<any>(`${this.entityUrl}/check/transactions/${txId}`);
  }

  public checkCommissionCode(commissionCode: string) {
    return http.get<any>(`${this.entityUrl}/checkCommissionCode/${commissionCode}`);
  }
}

export default new ContractService();
